<template>
  <div>
    <div class="form-group row">
      <div class="col-12">
        <h3>{{ lang.api }}</h3>
      </div>
    </div>

    <div class="mb-4">
      <a @click="onGenerateClick" tabindex="0" class="btn btn-primary">{{ lang.generate_api_token }}</a>
    </div>

    <div v-for="apiToken in items" v-bind:key="apiToken.id" class="mb-4" flex-row w-100 flex-nowrap>
      <div class="overflow-hidden">
        <div class="text-overflow-hidden">{{ apiToken.token }}</div>
        <div class="text-overflow-hidden small">{{ apiToken.created_at | datetime }}</div>
      </div>
      <div flex-1 style="min-width: 150px;" text-right>
        <a
          class="btn btn-primary btn-sm"
          tabindex="0"
          @keyup.enter="onCopyClick(apiToken)"
          @click="onCopyClick(apiToken)"
        >{{ i18n.app.common.copy }}</a>
        <a
          class="btn btn-danger btn-sm"
          tabindex="0"
          @keyup.enter="onDeleteClick(apiToken)"
          @click="onDeleteClick(apiToken)"
        >
          <i class="cs-delete"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ApiTokenService from "@/services/ApiTokenService";

const apiTokenService = new ApiTokenService();

export default {
  name: "account",
  props: ["items"],
  data() {
    return {
      lang: i18n.app.components.apitokenlist
    };
  },
  methods: {
    onGenerateClick() {
      apiTokenService.insert().then(apiToken => {
        this.items.push(apiToken);
      });
    },
    onCopyClick(apiToken) {
      this.$copyText(apiToken.token).then(
        e => {
          this.$snack.show(this.lang.copied_to_clipboard);
        },
        function(e) {
          alert(this.lang.copying_failed);
        }
      );
    },
    onDeleteClick(apiToken) {
      this.$dialog
        .confirm({
          title: i18n.app.common.warning,
          body: this.lang.api_delete_warning
        })
        .then(() => {
          userService.destroy(this.model.id).then(() => {
            this.$emit("delete", this.model);
          });
        });
      apiTokenService.destroy(apiToken.id).then(() => {
        const index = this.items.indexOf(apiToken);

        if (index > -1) this.items.splice(this.items.indexOf(apiToken), 1);
      });
    }
  },
  components: {}
};
</script>
